
import { DependencyCheckerPlugin } from './store/plugins/dependency-checker-plugin';
import BestfitOverviewApplication from './application/bestfit-overview-application';
import { BestfitOverviewReadyEvent } from 'interfaces';
import { IEventAggregationService } from '@studyportals/event-aggregation-service-interface';
import ModalHandler from './utils/modal-handler';
import globals from './utils/globals';

declare global {
	interface Window {
		rollbar: typeof Rollbar;
		rollbarIgnore: (...args) => boolean;
		EventAggregationService: IEventAggregationService;
	}
}
class Main {
	private bestfitOverviewApplication!: BestfitOverviewApplication;
	private modalHandler = new ModalHandler();

	public initialize(): void {
		try {
			new DependencyCheckerPlugin().initialize();

			this.modalHandler.constructModalManager();

			this.createBestfitOverviewApplication();

			document.addEventListener('render_best_fit_templates', () => {
				void this.bestfitOverviewApplication.renderWidgets();
			});

			// for study page rendering
			void this.bestfitOverviewApplication.renderWidgets();
		} catch (error) {
			// eslint-disable-next-line @typescript-eslint/no-unsafe-call
			globals.rollbar?.error(error);
		}

	}

	private createBestfitOverviewApplication(): void {

		this.bestfitOverviewApplication = new BestfitOverviewApplication();
		window['BestfitOverviewApplication'] = this.bestfitOverviewApplication;

		(window['EventAggregationService']).publishTo(
			BestfitOverviewReadyEvent.EventType,
			new BestfitOverviewReadyEvent(this.bestfitOverviewApplication),
		);
	}
}

const main = new Main();
export default main;
main.initialize();
